import { type AccessControlConfig } from 'legacy/components/AccessControl/accessControl.utils'
import { PickupRouteAccessControl } from 'gin-and-tonic/containers/nav/utils/pickupRouteAccessControl'

export const ShoppersRouteAccessControl: AccessControlConfig = {
  ...PickupRouteAccessControl,
}
